<template>
  <Drawer :closable="false"
          class-name="message-list"
          width="448"
          @on-close="handleClose"
          :value="messageListVisible">
    <div class="flex flex--align-center flex--justify-between" slot="header">
      <v-icon type="iconclear-24px" right-text="消息中心" @click.native="handleClose"></v-icon>
      <div class="action">
        <Button type="text" :disabled="unreadMsgs.length === 0" @click="handleReadAll">全部标记为已读</Button>
        <Button :type="showUnread ? 'primary' : 'default'"
                @click="handleToggleShowUnread"
                :disabled="unreadTotal === 0"
                shape="circle">只看未读: {{ unreadTotal }}条</Button>
      </div>
    </div>
    <v-no-data v-if="messages.length === 0"
      title="暂无更多消息"
      type="whole"
      icon="iconspeaker_notes_off-24px1"
      style="margin-top: 96px"
    ></v-no-data>
    <div v-else class="message-list__body" @scroll="handleScroll">
      <v-loading :loading="loading"></v-loading>
      <template v-for="msgList in timelineMsgs">
        <div :key="msgList.title" class="message-list__section" v-if="msgList.msgs.length > 0">
          <h2>{{ msgList.title }}</h2>
          <ul>
            <li v-for="msg in msgList.msgs"
              :key="msg.id"
              :unread="msg.status === 'UNREAD'"
              class="msg-item"
              @click="handleClickMsgItem(msg)"
            >
              <div class="title flex flex--align-center flex--justify-between">
                <v-icon type="iconpriority_high-24px" v-if="msg.indexNotif"></v-icon>
                <b class="point" v-else-if="msg.status === 'UNREAD'"></b>
                <h3>{{ msg.subject }}</h3>
                <p>{{ msg.timestamp | formatDate('YYYY-MM-DD') }}</p>
              </div>
              <div class="content">{{ msg.content }}</div>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </Drawer>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'messageList',
  data() {
    return {
      timer: null,
    }
  },
  computed: {
    ...mapState(['messageListVisible']),
    ...mapState('message', ['messages', 'loading', 'showUnread', 'unreadTotal']),
    ...mapGetters({
      unreadMsgs: 'message/unreadMessages',
    }),
    timelineMsgs() {
      let displayMsgs = this.showUnread ? this.unreadMsgs : this.messages;
      return [
        { title: '今天', msgs: displayMsgs.filter(m => m.timestamp >= moment().startOf('day')) },
        { title: '昨天', msgs: displayMsgs.filter(m => m.timestamp < moment().startOf('day') && m.timestamp >= moment().subtract(1, 'day').startOf('day')) },
        { title: '更早以前', msgs: displayMsgs.filter(m => m.timestamp < moment().subtract(1, 'day').startOf('day')) },
      ]
    },
  },
  methods: {
    ...mapActions({
      getMsgs: 'message/getMsgs',
      getMsgsOnDashboard: 'message/getMsgsOnDashboard',
      toggleShowUnread: 'message/toggleShowUnread',
      messageRead: 'message/msgRead',
      resetMsgs: 'message/resetMsgs',
    }),
    ...mapMutations(['updateState']),
    handleClose() {
      this.updateState({
        messageListVisible: false,
      });
    },
    handleToggleShowUnread() {
      this.toggleShowUnread();
    },
    handleClickMsgItem(msg) {
      if (msg.status === 'READ') return;
      this.messageRead([msg]);
    },
    handleReadAll() {
      this.messageRead(this.unreadMsgs);
    },
    handleScroll(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target; 
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.getMsgs();
      }
    },
    runGetMsgs() {
      this.resetMsgs();
      this.getMsgs();
      this.getMsgsOnDashboard();
      this.timer = setTimeout(_ => {
        this.runGetMsgs();
      }, 5 * 60 * 1000);
    }
  },
  created() {
    this.runGetMsgs();
  },
  destroyed() {
    clearTimeout(this.timer);
  }
};
</script>

<style lang="less">
  .message-list{
    .ivu-drawer-header{
      padding: 0 16px;
      height: 48px;
      line-height: 48px;
      color: rgba(0, 0, 0, 0.54);
      position: relative;
      .v-icon{
        vertical-align: middle;
        cursor: pointer;
        &:hover{
          color: rgba(0, 0, 0, 0.87);
        }
      }
      .title{
        vertical-align: middle;
        margin-left: 8px;
        font-weight: 500;
      }
      .action{
        height: 48px;
        .ivu-btn{
          box-shadow: none;
          height: 36px;
          font-weight: 500;
          &.ivu-btn-text{
            color: rgba(0, 0, 0, 0.54);
            &:hover{
              color: rgba(0, 0, 0, 0.87);
            }
            &[disabled]{
              color: rgba(0, 0, 0, 0.26);
              &:hover{
                color: rgba(0, 0, 0, 0.26);
              }
            }
          }
        }

        // .msg-item[unread]{

        //   cursor: pointer;
        //   &.all-read{

        //   }

        // }
      }
    }
    &__body {
      position: relative;
      height: 100%;
      overflow: auto;
      & .message-list__section:not(:last-child) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);  
      }
    }
    .ivu-drawer-body {
      padding: 0;
    }
    &__section{
      padding: 18px 8px 24px;
      // border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      h2{
        font-size: 24px;
        color: rgba(0, 0, 0, 0.54);
        font-weight: 500;
        line-height: 36px;
        margin-bottom: 10px;
        padding-left: 13px;
      }
      ul{
        li{
          background-color: rgba(0, 0, 0, 0.08);
          border-radius: 8px;
          padding: 14px 16px 24px;
          margin-bottom: 8px;
          &[unread]{
            cursor: pointer;
            &:hover{
              background-color: rgba(0, 0, 0, 0.12);
            }
            .title{
              .v-icon{
                color: rgb(255, 152, 0);
              }
              h3{
                color: rgb(81, 69, 139);
              }
            }
          }
          .title{
            margin-bottom: 14px;
            padding-left: 16px;
            position: relative;
            .v-icon{
              position: absolute;
              color: rgba(0, 0, 0, 0.12);
              left: -10px;
              top: -2px;
            }
            .point{
              position: absolute;
              background-color: rgb(255, 152, 0);
              left: -2px;
              top: 6px;
              width: 8px;
              height: 8px;
              border-radius: 4px;
            }
            h3{
              color: rgba(0, 0, 0, 0.54);
              font-weight: 700;
              font-size: 14px;
              line-height: 20px;
              position: relative;
            }
            p{
              color: rgba(0, 0, 0, 0.26);
              font-size: 12px;
              line-height: 18px;
            }
          }
          .content{
            color: rgba(0, 0, 0, 0.54);
            line-height: 24px;
            padding-left: 16px;
          }
        }
      }
    }
  }
</style>
